import { animated } from 'react-spring';

import { css, styled } from '../../../hooks/theme';

import { getCssElevacao, getCssFont } from '../../../styles';
import { Tokens } from '../../../types';

interface AlertContainerProps {
  type: 'success' | 'warning' | 'info' | 'error';
}
export const AlertContainer = styled(animated.div)<AlertContainerProps>`
  margin: 1rem 0.5rem;
  max-width: 532px;

  position: relative;

  display: flex;

  border-radius: 4px;
  ${props => {
    switch (props.type) {
      case 'success':
        return css`
          background: ${props.theme.colors.brand.primary[5]};
          color: ${props.theme.colors.feedback.success};
        `;
      case 'warning':
        return css`
          background: ${props.theme.colors.support.graneleiro[5]};
          color: ${props.theme.colors.feedback.warning};
        `;
      case 'info':
        return css`
          background: ${props.theme.colors.support.hopper[5]};
          color: ${props.theme.colors.support.hopper[100]};
        `;
      case 'error':
        return css`
          background: ${props.theme.colors.support.vanderleia[5]};
          color: ${props.theme.colors.feedback.error};
        `;
    }
  }}
  ${getCssElevacao(3)}

  button {
    height: 24px;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;

    &:hover {
      ${props => {
        switch (props.type) {
          case 'success':
            return css`
              color: ${props.theme.colors.brand.primary[140]};
            `;
          case 'warning':
            return css`
              color: ${props.theme.colors.support.graneleiro[140]};
            `;
          case 'info':
            return css`
              color: ${props.theme.colors.support.hopper[140]};
            `;
          case 'error':
            return css`
              color: ${props.theme.colors.support.vanderleia[140]};
            `;
        }
      }}
    }
  }

  .barra-vertical {
    height: 24px;
    ${props => {
      switch (props.type) {
        case 'success':
          return css`
            border-left: 1px solid ${props.theme.colors.brand.primary[120]};
          `;
        case 'warning':
          return css`
            border-left: 1px solid ${props.theme.colors.support.graneleiro[120]};
          `;
        case 'info':
          return css`
            border-left: 1px solid ${props.theme.colors.support.hopper[120]};
          `;
        case 'error':
          return css`
            border-left: 1px solid ${props.theme.colors.support.vanderleia[120]};
          `;
      }
    }}
  }
`;
AlertContainer.defaultProps = {
  theme: Tokens.eixods,
};

export const AlertBar = styled.div<AlertContainerProps>`
  min-width: 4px;
  border-radius: 4px 0px 0px 4px;
  ${props => {
    switch (props.type) {
      case 'success':
        return css`
          background: ${props.theme.colors.feedback.success};
        `;
      case 'warning':
        return css`
          background: ${props.theme.colors.feedback.warning};
        `;
      case 'info':
        return css`
          background: ${props.theme.colors.support.hopper[100]};
        `;
      case 'error':
        return css`
          background: ${props.theme.colors.feedback.error};
        `;
    }
  }}
`;
AlertBar.defaultProps = {
  theme: Tokens.eixods,
};

export const AlertContainerContent = styled.div`
  width: 100%;
  padding: 0.5625rem 1rem;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  gap: 10px;
`;
AlertContainerContent.defaultProps = {
  theme: Tokens.eixods,
};

export const AlertContent = styled.div<AlertContainerProps>`
  width: 100%;
  display: flex;
  justify-content: center;

  flex-direction: column;

  ${props => {
    switch (props.type) {
      case 'success':
        return css`
          color: ${props.theme.colors.brand.primary[140]};
        `;
      case 'warning':
        return css`
          color: ${props.theme.colors.support.graneleiro[140]};
        `;
      case 'info':
        return css`
          color: ${props.theme.colors.support.hopper[140]};
        `;
      case 'error':
        return css`
          color: ${props.theme.colors.support.vanderleia[140]};
        `;
    }
  }}
`;
AlertContent.defaultProps = {
  theme: Tokens.eixods,
};

export const AlertTitle = styled.div`
  ${getCssFont(Tokens.eixods.font.desktop.paragraph.p1.semibold)}
`;

export const AlertMessage = styled.div`
  ${getCssFont(Tokens.eixods.font.desktop.paragraph.p2.regular)}
`;

export const AlertIconContainer = styled.div`
  /* width: 24px; */
  display: flex;
  justify-content: center;
`;
